import { useContext } from 'react';
import styled from 'styled-components';
import Grid from '@mui/material/Grid';
import { WorksheetContext } from '../../context/WorksheetContext';
import Toggle from './Toggle';

const RentOptionCard = (props: ChildProps) => {
  const { title } = props;
  const { optionsValue } = useContext(WorksheetContext);
  const [options, setOptions] = optionsValue;

  const existingOption = options.find((option: any) => option.name === title);
  const alignment = existingOption?.rent ? 'yes' : 'no';

  const handleToggle = (event: any, newAlignment: string) => {
    const rent = newAlignment === 'yes';
    const otherOptions = options.filter((option: any) => option.name !== title);

    if (!rent && !existingOption?.purchaseAmount) {
      setOptions(otherOptions);
    } else {
      setOptions([
        ...otherOptions,
        {
          purchaseAmount: 0,
          amount: 0,
          ...existingOption,
          name: title,
          rent,
        },
      ]);
    }
  };

  return (
    <CardContainer item xs={12} sm={4} md={4}>
      <div style={{ padding: '20px', border: '1px solid #c4c4c4', borderRadius: '4px', height: '100%' }}>
        <h2>Would you like to rent {title}?</h2>
        <Toggle alignment={alignment} handleToggle={handleToggle} choice1="no" choice2="yes" size="small" />
      </div>
    </CardContainer>
  );
};

interface ChildProps {
  title: string;
}

const CardContainer = styled(Grid)`
  padding: 1rem;
  & h2 {
    margin-top: 0;
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
  }
`;

export default RentOptionCard;
